import React, { useState } from "react"
import {
	Typography,
	Grid
} from "@material-ui/core"

import {
	Breadcrumb,
	Loading,
	Notification
} from "@/components"

import { integrationInfo } from "@/utils/integration"

import Settings from "@/pages/Admin/Plugins/SuperlogicaPlugin/Settings"

import { SuperlogicaPluginSettingsData } from "@/protocols/SuperlogicaPluginProtocol"

import useDidMount from "@/hooks/useDidMount"
import useSuperlogicaApi from "@/hooks/useSuperlogicaApi"
import ApiService from "@/services/Api"

import useStyles from "@/pages/Admin/Plugins/SuperlogicaPlugin/styles"

const SuperlogicaPlugin = () => {
	const [loading, setLoading] = useState<boolean>(false)
	const [plugin, setPlugin] = useState<SuperlogicaPluginSettingsData>({} as SuperlogicaPluginSettingsData)

	const classes = useStyles()

	const { validatePlugin } = useSuperlogicaApi()

	const handleGetPluginSettings = async (): Promise<SuperlogicaPluginSettingsData | undefined> => {
		setLoading(true)

		let pluginSettingsData: SuperlogicaPluginSettingsData | undefined

		try {
			const response = await ApiService.get("/plugin-settings", {
				params: {
					pluginType: "superlogica"
				}
			})

			pluginSettingsData = response.data.dataValues as SuperlogicaPluginSettingsData

			setPlugin({
				...plugin,
				...pluginSettingsData
			})
		} catch (error) {
			Notification.error({ message: "Não foi possível carregar os dados do plugin." })
		}

		setLoading(false)

		return pluginSettingsData
	}

	const handleUpdatePlugin = (data: Partial<SuperlogicaPluginSettingsData>) => {
		setPlugin({
			...plugin,
			...data
		})
	}

	useDidMount(async () => {
		const pluginSettingsData = await handleGetPluginSettings()

		const hasSavedCredentials = pluginSettingsData?.status === "enabled" &&
			Boolean(pluginSettingsData?.settings?.app_token) &&
			Boolean(pluginSettingsData?.settings?.access_token)

		if (pluginSettingsData?.id && hasSavedCredentials) {
			await validatePlugin()
		}
	})

	return (
		<Loading loading={loading}>
			<Grid
				container
				direction="column"
				spacing={3}
			>
				<Grid item xs={12}>
					<Grid
						alignItems="center"
						justifyContent="space-between"
						container
					>
						<Typography
							variant="h4"
							color="textPrimary"
						>
							<Breadcrumb
								data={[
									{ name: "Plugins", pathname: "/admin/plugins" },
									{ name: "Superlógica", pathname: "/admin/plugins/superlogica" }
								]}
							/>
						</Typography>

						<img
							src={integrationInfo.Superlogica?.logo}
							alt="Superlógica logo"
							className={classes.logoImg}
						/>
					</Grid>
				</Grid>

				<Grid item xs={12}>
					<Settings
						plugin={plugin}
						onUpdate={handleUpdatePlugin}
					/>
				</Grid>
			</Grid>
		</Loading>
	)
}

export default SuperlogicaPlugin
